import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  username;
  password;
  hideLoader =true;
  cacherButton = false;
  constructor(private apiService:ApiService,private router:Router,public toastr:NbToastrService, public authService: AuthService,) { }

  ngOnInit() {

  }

  login(){

      this.hideLoader = false;
      this.cacherButton = true;
    
      const auth =  this.authService;
      auth.authenticate().subscribe(data =>{

      localStorage.setItem('cms_token', JSON.stringify(data));

      // on attribut un role par defaut en attendant d'implémenter la fonctionnalité d'attribution des rôles
      // this.token.user.roles = ['ADMIN'];

      this.cacherButton = false;
      this.hideLoader = true;

      auth.login();

        /* setTimeout(() => {
          window.location.reload();
        }, 1000); */

    },(err) =>{
     
        this.cacherButton = false;
        this.hideLoader = true;

        console.log( err );
        if( err.error.code !== undefined) {

          // this.toastr.danger("vos identifiants ne correspondent pas","erreur");
          this.toastr.danger(err.error.message, "Erreur " + err.error.code);

        } else {

          this.toastr.danger("Vérifiez votre connexion internet et réessayez","erreur de connexion");
  
        }
        
       
    
    })
  
}

}
